import Swal from 'sweetalert2';
import {
  GET_ARCHIVED_USER,
  GET_DASHBOARD_ACTIVITY,
  GET_DASHBOARD_APPROACHING_DEAD,
  GET_DASHBOARD_MEMBER_SUMMARY,
  GET_DASHBOARD_MISSED_DEAD,
  GET_DASHBOARD_PROJECT_LIST,
  GET_DASHBOARD_SCREENSHOT,
  GET_DASHBOARD_SUMMARY,
  GET_DASHBOARD_TASK_LIST,
  GET_DASHBOARD_TASK_SUMMARY,
  GET_DASHBOARD_TEAM_LIST,
  GET_DASHBOARD_TODAYS_ACTIVITY,
  GET_DASHBOARD_TOP_MEMBERS,
  GET_DOMAIN_USER,
  GET_DOMAIN_DETAILS,
  GET_TIMEZONES,
  GET_HOLIDAY__LIST,
  GET_HOLIDAY_BY_ID,
  GET_LEAVE_BALANCE,
  GET_LEAVE_LIST,
  GET_LEAVE_POLICY,
  GET_LEAVE_POLICY_BY_ID,
  GET_MEMBER_BY_ID,
  GET_MEMBER_INVITE_LINK,
  GET_MEMBER_LIST,
  GET_MONITORING_DAILY_ACTIVITY,
  GET_MONITORING_MEMBER,
  GET_MONITORING_PROJECT,
  GET_MONITORING_SCREENSHOTS,
  GET_ONBOARD_MEMBERS_LIST,
  GET_ONBOARD_STATUS,
  GET_ONBOARD_TEAMS_LIST,
  GET_ONBOARD_USER,
  GET_PROJECT_BY_ID,
  GET_PROJECT_TASK_BY_ID,
  GET_PROJECT_TASK_LIST,
  GET_PROJECTS,
  GET_REALTIME_LIST,
  GET_REALTIME_MEMBER_LIST,
  GET_REALTIME_PROJECT_LIST,
  GET_REPORTS_ACTIVITY_LEVEL,
  GET_REPORTS_ATTENDANCE,
  GET_REPORTS_ATTENDANCE_MINUTE_WISE,
  GET_REPORTS_TRACKED_HOURS,
  GET_REPORTS_TRACKED_HOURS_MINUTE_WISE,
  GET_SCREENSHOT_DETAILS,
  GET_TEAM_LIST,
  GET_TIMEEDITOR_LIST,
  GET_TIMESHEET,
  GET_TIMESHEET_MEMBER,
  GET_TIMESHEET_PROJECT_LIST,
  GET_TIMESHEET_TASK_LIST,
  GET_TITLE_LIST,
  SET_LOADING,
  USER_LOGIN_DETAILS,
  GET_IMAGE_DATA,
  GET_DOMAIN_USER_BY_ID,
  GET_SUPERADMIN_DASHBOARD_DATA,
  GET_SCHEDULE_REPORT_LIST,
  GET_TIMEZONE_LIST,
  GET_SCHEDULE_REPORT_BYID,
  GET_SHARE_REPORT,
  GET_SHARE_REPORT_PUBLIC,
  GET_WORKSPACE,
  GET_EMPLOYEE_DOMAIN,
  GET_EMPLOYEE_DASHBOARD,
  GET_CHAT_EMPLOYEE_LIST,
  GET_EMPLOYEE_WORKSPACE,
  GET_EMPLOYEE_TIMESHEET_MEMBER,
  GET_EMPLOYEE_TIMESHEET_PROJECT,
  GET_EMPLOYEE_TIMESHEET_PROJECT_TASK,
  GET_EMPLOYEE_TIMESHEET,
  GET_TIME_REQUEST,
  GET_INTERNET_SPEED_LOCATION,
  GET_INTERNET_SPEED_LOCATION_SUMMARY,
  GET_EMPLOYEE_APP_USAGE,
  GET_EMPLOYEE_PAST_ACTIVITIES,
  GET_EMPLOYEE_PROJECT_TASK_LIST,
  GET_EMPLOYEE_PROJECTS,
  GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE,
  GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE,
} from './type';
import axios from 'axios';
import Constant from '../Constant';
import { toast } from 'react-toastify';
import moment from 'moment';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
  },
};

const xlsxConfig = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
    'Content-Type': 'application/json',
    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  responseType: 'blob',
};

const configFormData = {
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
  },
};
export const setLoading = (data) => (dispatch) => {
  dispatch({
    type: SET_LOADING,
    payload: data,
  });
};

const count = {
  offset: 0,
  limit: 10,
};

const today = new Date();
const dayOfWeek = today.getDay();
const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
const monday = new Date(today);
monday.setDate(today.getDate() - diff);
const sunday = new Date(today);
sunday.setDate(today.getDate() + diff);

export const loginUser = (data, role) => async (dispatch) => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `${role}/auth/login`,
      data
    );

    if (res?.data?.success) {
      dispatch({
        type: USER_LOGIN_DETAILS,
        payload: res.data,
      });

      Swal.fire({
        title: 'Login successful',
        text: '',
        type: 'success',
        confirmButtonColor: 'green',
        confirmButtonText: 'Close',
      });

      localStorage.setItem('loged_In_auth', res.data.data.token);

      if (role === 'domain') {
        localStorage.setItem('domainName', res.data.data[role]?.domainName);
        localStorage.setItem(
          'domainDetails',
          JSON.stringify(res.data.data[role])
        );
        localStorage.setItem('userId', res.data.data[role].id);
        localStorage.setItem('ad_email', res.data.data[role].email);
        localStorage.setItem('role', role);
        localStorage.setItem('loged_In', true);
      } else if (role === 'employeeWeb') {
        localStorage.setItem('firstName', `${res.data.data?.user.firstName}`);
        localStorage.setItem('lastName', `${res.data.data?.user.lastName}`);
        localStorage.setItem('userId', res.data.data?.user.id);
        localStorage.setItem('ad_email', res.data.data?.user.email);
        localStorage.setItem('role', role);
        localStorage.setItem('employee', true);
      } else {
        localStorage.setItem('firstName', `${res.data.data?.user.firstName}`);
        localStorage.setItem('lastName', `${res.data.data?.user.lastName}`);
        localStorage.setItem('userId', res.data.data?.user.id);
        localStorage.setItem('ad_email', res.data.data?.user.email);
        localStorage.setItem('role', role);
        localStorage.setItem('loged_In', true);
        if (res.data.data?.user?.media)
          localStorage.setItem('logoUrl', res.data.data?.user.media.url);
      }

      // localStorage.setItem("ucs-mobile", res.data.data.contactNo);
      // localStorage.setItem("RoleId", res.data.data.RoleId);

      window.location.href = '/';
      window.location.reload();
    }
  } catch (err) {
    const errorMessage = err.response?.data?.error || 'Invalid user';

    Swal.fire({
      title: errorMessage,
      type: 'error',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Close',
      customClass: {
        title: 'swal-custom-title',
      },
    });
  }
};

// Forgot Password
export const forgotPasswordRequest = (data, role) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `${role}/auth/forgot-password/request`,
      data
    );

    if (res?.data?.success) {
      return res.data;
    }
  } catch (err) {
    const errorMessage = err.response?.data?.error || 'Email does not exist';

    Swal.fire({
      title: errorMessage,
      type: 'error',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Close',
      customClass: {
        title: 'swal-custom-title',
      },
    });
  }
};

export const forgotPasswordOTP = (data, role) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `${role}/auth/forgot-password/verify`,
      data
    );

    if (res?.data?.success) {
      Swal.fire({
        title: 'OTP verified successfully',
        text: '',
        type: 'success',
        confirmButtonColor: 'green',
        confirmButtonText: 'Close',
      });

      window.location.href = '/login';
      window.location.reload();
    }
  } catch (err) {
    const errorMessage = err.response?.data?.error || 'Invalid OTP';

    Swal.fire({
      title: errorMessage,
      type: 'error',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Close',
      customClass: {
        title: 'swal-custom-title',
      },
    });
  }
};

// Get Teams
export const getTeams = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/team/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TEAM_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TEAM_LIST,
        payload: [],
      });
    });
};

// Add Teams

export const addTeam = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/team/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-center',
      });
      dispatch(getTeams());
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        toast.error(err?.response?.data, {
          position: 'top-center',
        });
      } else {
        toast.error(err?.response?.data?.error, {
          position: 'top-center',
        });
      }
    });
};
// Add Teams

export const editTeam = (data, deleted) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/team/edit`, data, config)
    .then((res) => {
      toast.success(
        deleted ? 'Successfully Deleted !' : 'Successfully Updated !',
        {
          position: 'top-right',
        }
      );
      dispatch(getTeams());
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        toast.error(err?.response?.data, {
          position: 'top-right',
        });
      } else {
        toast.error(err?.response?.data?.error, {
          position: 'top-right',
        });
      }
    });
};

// Get Title
export const getTitle = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/title/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TITLE_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TITLE_LIST,
        payload: [],
      });
    });
};

// Add Title
export const addTitle = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/title/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-center',
      });
      dispatch(getTitle());
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        toast.error(err?.response?.data, {
          position: 'top-right',
        });
      } else {
        toast.error(err?.response?.data?.error, {
          position: 'top-right',
        });
      }
    });
};
// Add Teams

export const editTitle = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/title/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      dispatch(getTitle());
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        toast.error(err?.response?.data, {
          position: 'top-right',
        });
      } else {
        toast.error(err?.response?.data?.error, {
          position: 'top-right',
        });
      }
    });
};

// Get Member
export const getMember = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/people/member/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_MEMBER_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_MEMBER_LIST,
        payload: [],
      });
    });
};
// Get Member
export const getMemberArchived = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_ARCHIVED_USER,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ARCHIVED_USER,
        payload: [],
      });
    });
};
export const getMemberOnboard = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/onboard/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_ONBOARD_USER,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ONBOARD_USER,
        payload: [],
      });
    });
};
export const getMemberOnboardStatus = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/onboard/status`, data, config)
    .then((res) => {
      dispatch({
        type: GET_ONBOARD_STATUS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ONBOARD_STATUS,
        payload: [],
      });
    });
};
export const getOnboardTeam = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/people/member/onboard/team/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_ONBOARD_TEAMS_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ONBOARD_TEAMS_LIST,
        payload: [],
      });
    });
};
export const getOnBoardMmber = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/people/member/onboard/member/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_ONBOARD_MEMBERS_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ONBOARD_MEMBERS_LIST,
        payload: [],
      });
    });
};

// Members Export CSv
export const getMembersCSV = (data, type) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/v2/people/member${type || ''}/list/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Members Export XLSX
export const getMembersXLSX = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/people/member/list/export/xlsx`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Delete Team user
export const AddTeamMember = (data, filters) => async (dispatch) => {
  return axios
    .post(Constant.getAPI() + `user/people/member/team/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added!', {
        position: 'top-right',
      });
      dispatch(getMember(filters ?? count));

      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Add Title user
export const AddTitleMember = (data, filters) => async (dispatch) => {
  return axios
    .post(Constant.getAPI() + `user/people/member/title/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added!', {
        position: 'top-right',
      });
      dispatch(getMember(filters ?? count));

      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Delete Team user
export const deleteMember = (data, filters) => async (dispatch) => {
  return axios
    .post(Constant.getAPI() + `user/people/member/team/remove`, data, config)
    .then((res) => {
      toast.success('Successfully Removed !', {
        position: 'top-right',
      });
      dispatch(getMember(filters ?? count));
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Delete Team user
export const deleteMemberTitle = (data, filters) => async (dispatch) => {
  return axios
    .post(Constant.getAPI() + `user/people/member/title/remove`, data, config)
    .then((res) => {
      toast.success('Successfully Removed!', {
        position: 'top-right',
      });
      dispatch(getMember(filters ?? count));
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Member
export const getMemberById = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_MEMBER_BY_ID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_MEMBER_BY_ID,
        payload: [],
      });
    });
};

// Update Member
export const updateMember = (data, filters) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/edit`, data, config)
    .then((res) => {
      toast.success('Successfully updated !', {
        position: 'top-right',
      });
      dispatch(getMember(filters ?? count));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Pojec //
export const getProjects = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_PROJECTS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_PROJECTS,
        payload: [],
      });
    });
};

export const getEmployeeProjects = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `employeeWeb/project/project/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_PROJECTS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_PROJECTS,
        payload: [],
      });
    });
};

// Add Project //
export const addProject = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      dispatch(getProjects(count));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Projrct By ID
export const getProjectById = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_PROJECT_BY_ID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_PROJECT_BY_ID,
        payload: [],
      });
    });
};

export const UploadMedia = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/media/add`, data, configFormData)
    .then((res) => {
      console.log('Image upload', res.data);
      if (res.data.success) {
        dispatch({
          type: GET_IMAGE_DATA,
          payload: res.data.data[0],
        });
        Swal.fire({
          title: 'Uploaded',
          text: 'Your file has been successfully Uploaded',
          icon: 'success',
          button: 'Cancel',
        });
      } else {
        dispatch({
          type: GET_IMAGE_DATA,
          payload: {},
        });
      }
    })
    .catch((err) => {
      // console.log("err", err.response.data);
      Swal.fire({
        title: 'Error',
        text: err.response.data.message,
        icon: 'error',
        button: 'Cancel',
      });
    });
};

// Get Member Invite Link
export const getInviteLink = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/inviteLink`, data, config)
    .then((res) => {
      dispatch({
        type: GET_MEMBER_INVITE_LINK,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_MEMBER_INVITE_LINK,
        payload: [],
      });
    });
};

// Add Project //

export const addMeberInvite = (data, isRegistration) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${Constant.getAPI()}user/auth/register`,
      data
    );

    if (isRegistration) {
      localStorage.setItem('loged_In_auth', res.data.data.token);
      localStorage.setItem('firstName', `${res.data.data.user.firstName}`);
      localStorage.setItem('lastName', ` ${res.data.data.user.lastName}`);
      localStorage.setItem('loged_In', false);
      localStorage.setItem('userId', res.data.data.user.id);
      localStorage.setItem('ad_email', res.data.data.user.email);
      window.location.href =
        data.joiningToken === undefined ? '/registered' : '';
    }

    toast.success('Successfully Registered!', {
      position: 'top-right',
    });
    return { success: true };
  } catch (err) {
    toast.error(err?.response?.data?.error || 'Registration failed', {
      position: 'top-right',
    });
    return { success: false };
  }
};

// Update Profile
export const updateProfile = (data, emails) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/auth/detail/update`, data, config)
    .then(async (res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      localStorage.setItem('loged_In', true);
      localStorage.setItem('role', 'user');

      if (emails?.length !== 0) {
        await dispatch(EmailInvite(emails));
      }

      window.location.href = '/';
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get DashBoard Team List
export const getDashboardTeamList = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/dashboard/team/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_TEAM_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_TEAM_LIST,
        payload: [],
      });
    });
};
// Get DashBoard Summary
export const getDashboardSummary = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/dashboard/summary`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_SUMMARY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_SUMMARY,
        payload: [],
      });
    });
};
// Get DashBoard Today Activity
export const getDashboardTodayAct = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/dashboard/todays-activity`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_TODAYS_ACTIVITY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_TODAYS_ACTIVITY,
        payload: [],
      });
    });
};

// Get DashBoard Activity
export const getDashboardActivity = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/activity`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_ACTIVITY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_ACTIVITY,
        payload: [],
      });
    });
};
// Get DashBoard PROJECT LIST
export const getDashboardProjectList = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/project/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_PROJECT_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_PROJECT_LIST,
        payload: [],
      });
    });
};
// Get DashBoard Task LIST
export const getDashboardTaskList = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/dashboard/task/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_TASK_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_TASK_LIST,
        payload: [],
      });
    });
};
// Get DashBoard Task Summary
export const getDashboardTaskSummary = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/task-summary`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_TASK_SUMMARY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_TASK_SUMMARY,
        payload: [],
      });
    });
};
// Get DashBoard Member Summary
export const getDashboardMemberSummary = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/member/summary`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_MEMBER_SUMMARY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_MEMBER_SUMMARY,
        payload: [],
      });
    });
};
// Get DashBoard Screen Shot
export const getDashboardScreenshot = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/screenshot`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_SCREENSHOT,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_SCREENSHOT,
        payload: [],
      });
    });
};
// Get DashBoard Top Members
export const getDashboardTopMembers = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/top-members`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_TOP_MEMBERS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_TOP_MEMBERS,
        payload: [],
      });
    });
};
// Get DashBoard Missed Deadline
export const getDashboardMissedDeadline = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/dashboard/deadline/missed`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_MISSED_DEAD,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_MISSED_DEAD,
        payload: [],
      });
    });
};
// Get DashBoard Missed Deadline
export const getDashboardApproachingDeadline = (data) => async (dispatch) => {
  await axios
    .post(
      Constant.getAPI() + `user/dashboard/deadline/approaching`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_DASHBOARD_APPROACHING_DEAD,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DASHBOARD_APPROACHING_DEAD,
        payload: [],
      });
    });
};

export const AddProjectMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/member/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      dispatch(getProjectById({ id: data?.projectId }));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updateProjectMember = (data, ID) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/member/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      if (ID) dispatch(getProjectById({ id: ID }));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const RemoveProjectMember = (data, ID) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/project/project/member/remove`,
      data,
      config
    )
    .then((res) => {
      toast.success('Successfully Removed !', {
        position: 'top-right',
      });
      // dispatch(getTeams())
      console.log('response', res);
      dispatch(getProjectById({ id: ID }));
      dispatch(getProjects());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Tracked Hour Reports
export const getTrackedHours = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/report/tracked-hours`, data, config)
    .then((res) => {
      dispatch({
        type: GET_REPORTS_TRACKED_HOURS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REPORTS_TRACKED_HOURS,
        payload: [],
      });
    });
};

// Get Tracked Hour Reports Minute Wise

// Without idle minutes

export const getTrackedHourIdleMinuteWise =
  (data, latest) => async (dispatch) => {
    await axios
      .post(
        Constant.getAPI() +
          `user${latest ? '/v3' : ''}/report/tracked-hours/idle-minute-wise`,
        data,
        config
      )
      .then((res) => {
        dispatch({
          type: GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE,
          payload: res?.data?.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE,
          payload: [],
        });
      });
  };

// With idle minutes

export const getTrackedHourMinuteWise = (data) => async (dispatch) => {
  await axios
    .post(
      Constant.getAPI() + `user/report/tracked-hours/minute-wise`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_REPORTS_TRACKED_HOURS_MINUTE_WISE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REPORTS_TRACKED_HOURS_MINUTE_WISE,
        payload: [],
      });
    });
};

// Get ACTIVITY LEVEL REPORTS
export const getActivityLevel = (data) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/report/activity-level`, data, config)
    .then((res) => {
      dispatch({
        type: GET_REPORTS_ACTIVITY_LEVEL,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REPORTS_ACTIVITY_LEVEL,
        payload: [],
      });
    });
};
// Get ATTENDANCE REPORTS
export const getAttendance = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/report/attendance`, data, config)
    .then((res) => {
      dispatch({
        type: GET_REPORTS_ATTENDANCE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REPORTS_ATTENDANCE,
        payload: [],
      });
    });
};

// Get Attendance Reports Minute Wise

// Without idle minutes

export const getAttendanceIdleMinuteWise =
  (data, latest) => async (dispatch) => {
    await axios
      .post(
        Constant.getAPI() +
          `user${latest ? '/v3' : ''}/report/attendance/idle-minute-wise`,
        data,
        config
      )
      .then((res) => {
        dispatch({
          type: GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE,
          payload: res?.data?.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE,
          payload: [],
        });
      });
  };

// With idle minutes

export const getAttendanceMinuteWise = (data) => async (dispatch) => {
  await axios
    .post(
      Constant.getAPI() + `user/report/attendance/minute-wise`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_REPORTS_ATTENDANCE_MINUTE_WISE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REPORTS_ATTENDANCE_MINUTE_WISE,
        payload: [],
      });
    });
};

// Get Project Task
export const getProjectTask = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/task/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_PROJECT_TASK_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_PROJECT_TASK_LIST,
        payload: [],
      });
    });
};

export const getEmployeeProjectTask = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employeeWeb/project/project/task/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_PROJECT_TASK_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_PROJECT_TASK_LIST,
        payload: [],
      });
    });
};

// Get Project Task
export const getProjectTaskById = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/task/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_PROJECT_TASK_BY_ID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_PROJECT_TASK_BY_ID,
        payload: [],
      });
    });
};

// Add Project //
export const addProjectTask = (payload) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/task/add`, payload, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      // var data = {
      //   projectId: payload?.projectId,
      // };
      dispatch(getProjectTask(count));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Add Project //
export const updateProjectTask = (payload, project) => (dispatch) => {
  // console.log("payload" , payload , project);

  axios
    .post(Constant.getAPI() + `user/project/project/task/edit`, payload, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });

      dispatch(getProjectTask(count));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Monitoring Member
export const getMonitoringMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/monitoring/member/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_MONITORING_MEMBER,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_MONITORING_MEMBER,
        payload: [],
      });
    });
};
// Get Monitoring Member
export const getMonitoringProject = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/monitoring/project/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_MONITORING_PROJECT,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_MONITORING_PROJECT,
        payload: [],
      });
    });
};
// Get Monitoring Member
export const getMonitoringDailyActivity =
  (data, latest) => async (dispatch) => {
    await axios
      .post(
        Constant.getAPI() +
          `user${latest ? '/v3' : ''}/monitoring/daily-activity`,
        data,
        config
      )
      .then((res) => {
        dispatch({
          type: GET_MONITORING_DAILY_ACTIVITY,
          payload: res?.data?.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_MONITORING_DAILY_ACTIVITY,
          payload: [],
        });
      });
  };

// Get Internet Speed / location
export const getInternetSpeedLocation = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/internetSpeed/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_INTERNET_SPEED_LOCATION,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_INTERNET_SPEED_LOCATION,
        payload: [],
      });
    });
};

export const getInternetSpeedLocationSummary = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/internetSpeed/summary`, data, config)
    .then((res) => {
      dispatch({
        type: GET_INTERNET_SPEED_LOCATION_SUMMARY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_INTERNET_SPEED_LOCATION_SUMMARY,
        payload: {},
      });
    });
};

// Get Monitoring Member
export const getMonitoringScreenshot = (data, latest) => async (dispatch) => {
  await axios
    .post(
      Constant.getAPI() + `user${latest ? '/v3' : ''}/monitoring/screenshotsV2`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_MONITORING_SCREENSHOTS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_MONITORING_SCREENSHOTS,
        payload: [],
      });
    });
};

// Delete Screenshot
export const deleteScreenshot = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/monitoring/screenshot/remove`, data, config)
    .then((res) => {
      toast.success('Successfully Removed !', {
        position: 'top-right',
      });
      window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Monitoring Member
export const getRealTime = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/realtime/realtime`, data, config)
    .then((res) => {
      dispatch({
        type: GET_REALTIME_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REALTIME_LIST,
        payload: [],
      });
    });
};
// Get Monitoring Member
export const getRealTimeMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/realtime/member/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_REALTIME_MEMBER_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REALTIME_MEMBER_LIST,
        payload: [],
      });
    });
};
export const getRealTimeProject = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/realtime/project/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_REALTIME_PROJECT_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_REALTIME_PROJECT_LIST,
        payload: [],
      });
    });
};
// Get Monitoring Member
export const getHoliday = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/holiday/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_HOLIDAY__LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_HOLIDAY__LIST,
        payload: [],
      });
    });
};
// Get Holiday ByID
export const getHolidayByID = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/holiday/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_HOLIDAY_BY_ID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_HOLIDAY_BY_ID,
        payload: [],
      });
    });
};

export const EmailInvite = (payload) => async (dispatch) => {
  await axios
    .post(Constant.getAPI() + `user/people/member/invite/mail`, payload, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });

      dispatch(getMember());
      dispatch(getMemberOnboard());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const upLoadBulk = (payload) => (dispatch) => {
  // console.log("payload" , payload , project);

  axios
    .post(
      Constant.getAPI() + `user/people/member/invite/bulk`,
      payload,
      configFormData
    )
    .then((res) => {
      toast.success('Successfully uploaded !', {
        position: 'top-right',
      });

      dispatch(getMember());
      dispatch(getMemberOnboard());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const addHoliday = (payload) => (dispatch) => {
  // console.log("payload" , payload , project);

  axios
    .post(Constant.getAPI() + `user/timeoff/holiday/add`, payload, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });

      var dta = {
        limit: 10,
        offset: 0,
        startDate: moment(monday).format('YYYY-MM-DD'),
        endDate: moment(today).format('YYYY-MM-DD'),
      };
      dispatch(getHoliday(dta));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updateHoliday = (payload, filters) => (dispatch) => {
  // console.log("payload" , payload , project);

  axios
    .post(Constant.getAPI() + `user/timeoff/holiday/edit`, payload, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      var dta = {
        limit: 10,
        offset: 0,
        startDate: filters?.startDate || moment(monday).format('YYYY-MM-DD'),
        endDate: filters?.endDate || moment(today).format('YYYY-MM-DD'),
      };
      dispatch(getHoliday(dta));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Holiday ByID
export const getLeave = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_LEAVE_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_LEAVE_LIST,
        payload: [],
      });
    });
};
// Get Leave  POlicy
export const getLeavePolicy = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/policy/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_LEAVE_POLICY,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_LEAVE_POLICY,
        payload: [],
      });
    });
};

export const addLeave = (payload) => (dispatch) => {
  // console.log("payload" , payload , project);

  axios
    .post(Constant.getAPI() + `user/timeoff/leave/add`, payload, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      var dta = {
        limit: 10,
        offset: 0,
        startDate: moment(monday).format('YYYY-MM-DD'),
        endDate: moment(today).format('YYYY-MM-DD'),
      };
      dispatch(getLeave(dta));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

// Get Time Sheet Member
export const getTimeSheetMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/member/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIMESHEET_MEMBER,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIMESHEET_MEMBER,
        payload: [],
      });
    });
};
// Get Time Sheet
export const getTimeSheet = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/timesheet/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIMESHEET,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIMESHEET,
        payload: [],
      });
    });
};
// Get Time Sheet Project Task
export const getTimeSheetTask = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/project/task/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIMESHEET_TASK_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIMESHEET_TASK_LIST,
        payload: [],
      });
    });
};
// Add Time Sheet
export const addTimeSheet = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/v2/timesheet/timesheet/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      // dispatch(getLeavePolicy())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Get Leave Balance
export const getLeaveBalance = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/balance/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_LEAVE_BALANCE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_LEAVE_BALANCE,
        payload: [],
      });
    });
};
export const getLeavePolicyByID = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/policy/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_LEAVE_POLICY_BY_ID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_LEAVE_POLICY_BY_ID,
        payload: [],
      });
    });
};

// Delete Leave
export const removeLeave = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/remove`, data, config)
    .then((res) => {
      toast.success('Successfully Removed !', {
        position: 'top-right',
      });
      dispatch(getLeave());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Add Leave Policy
export const addLeavePolicy = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/policy/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      dispatch(getLeavePolicy());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
// Update Leave policy
export const updateLeavePolicy = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timeoff/leave/policy/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      dispatch(getLeavePolicy(count));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updateProject = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/project/project/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      dispatch(getProjects());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

export const getTimeEditor = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/time-editor/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIMEEDITOR_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIMEEDITOR_LIST,
        payload: [],
      });
    });
};
export const getTimesheetProject = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/project/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIMESHEET_PROJECT_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIMESHEET_PROJECT_LIST,
        payload: [],
      });
    });
};

// Activity Level Report Export CSv
export const getActivityLevelCSV = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/activity-level/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Activity Level Report Export XLSX
export const getActivityLevelXLSX = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/activity-level/export/xlsx`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// ATtendance Report Export CSV

export const getAttendanceCSV = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/attendance/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Attendance Report Export XLSX
export const getAttendanceXLSX = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/attendance/export/xlsx`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// ATtendance Report Export CSV

// Without idle minutes

// export const getAttendanceIdleMinuteWiseCSV = (data, latest) => async () => {
//   try {
//     const res = await axios.post(
//       Constant.getAPI() +
//         `user${latest ? '/v3' : ''}/report/attendance/idle-minute-wise/export/csv`,
//       data,
//       config
//     );

//     return res?.data;
//   } catch (err) {
//     return err;
//   }
// };
export const getAttendanceIdleMinuteWiseCSV =
    (data, latest) => async () => {
        try {
            const res = await axios.post(
                Constant.getAPI() +
                    `user${latest ? '/v3' : ''}/report/attendance/idle-minute-wise/export/csv`,
                data,
                {
                    ...config,
                    responseType: 'blob',
                }
            );

            return res?.data;
        } catch (err) {
            return err;
        }
    };

// With idle minutes

export const getAttendanceMinuteWiseCSV = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/attendance/minute-wise/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Tracked Hours Report Export CSV
export const getTrackedHoursCSV = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/tracked-hours/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Tracked Hours Report Export XLSX
export const getTrackedHoursXLSX = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/tracked-hours/export/xlsx`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Tracked Hours Report Minute Wise Export CSV

// Without idle minutes
// export const getTrackedHoursIdleMinuteWiseCSV = (data, latest) => async () => {
//   try {
//     const res = await axios.post(
//       Constant.getAPI() +
//         `user${latest ? '/v3' : ''}/report/tracked-hours/idle-minute-wise/export/csv`,
//       data,
//       config
//     );

//     return res?.data;
//   } catch (err) {
//     return err;
//   }
// };
export const getTrackedHoursIdleMinuteWiseCSV =
    (data, latest) => async () => {
        try {
            const res = await axios.post(
                Constant.getAPI() +
                    `user${latest ? '/v3' : ''}/report/tracked-hours/idle-minute-wise/export/csv`,
                data,
                {
                    ...config,
                    responseType: 'blob',
                }
            );

            return res?.data;
        } catch (err) {
            return err;
        }
    };

// With idle minutes
export const getTrackedHoursMinuteWiseCSV = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/tracked-hours/minute-wise/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

//  Timesheet Export CSV
export const getTimesheetCSV = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/timesheet/timesheet/list/export/csv`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Timesheet Export XLSX
export const getTimesheetXLSX = (data) => async () => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/timesheet/timesheet/list/export/xlsx`,
      data,
      config
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};

// Timesheet Export XLSX
export const getScreenshotDeatil = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/monitoring/screenshots/activityV2`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_SCREENSHOT_DETAILS,
        payload: res?.data,
      });
      console.log('response', res);
    })
    .catch((err) => {
      dispatch({
        type: GET_SCREENSHOT_DETAILS,
        payload: [],
      });
    });
};

export const addMemberArchive = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/archive`, data, config)
    .then((res) => {
      toast.success('Successfully Archived !', {
        position: 'top-right',
      });
      // dispatch(getMember())
      window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const sendMemberReminder = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/people/member/onboard/reminder/send`,
      data,
      config
    )
    .then((res) => {
      toast.success('Successfully Sent !', {
        position: 'top-right',
      });
      dispatch(getMember());
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const restoreMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/restore`, data, config)
    .then((res) => {
      toast.success('Successfully Restored !', {
        position: 'top-right',
      });
      // dispatch(getMember())
      // dispatch(getMemberArchived())
      window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const deleteArchiveMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/people/member/remove`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      // dispatch(getMember())
      // dispatch(getMemberArchived())
      window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

export const deleteOnboardingMember = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/v2/people/member/onboard/remove`,
      data,
      config
    )
    .then((res) => {
      toast.success('Member Successfully Deleted !', {
        position: 'top-right',
      });
      window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

export const getScheduleReport = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/report/schedule/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_SCHEDULE_REPORT_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getScheduleReportByID = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/report/schedule/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_SCHEDULE_REPORT_BYID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getTimeZone = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/report/schedule/timezone/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_TIMEZONE_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getShareReport = (data) => async (dispatch) => {
  try {
    const res = await axios.post(
      Constant.getAPI() + `user/report/tracked-hours/public/link`,
      data,
      config
    );

    return res?.data?.data;
  } catch (err) {
    toast.error(err?.response?.data?.error, {
      position: 'top-right',
    });
  }
};
export const getShareReportPublic = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/report/tracked-hours/public`, data)
    .then((res) => {
      dispatch({
        type: GET_SHARE_REPORT_PUBLIC,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

export const addScheduleReport = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/report/schedule/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      dispatch(getScheduleReport());
      // window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updateScheduleReport = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/report/schedule/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      dispatch(getScheduleReport());
      // window.location.reload();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

export const getDomainUser = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/user/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DOMAIN_USER,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getAdminUser = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/chatEmployee/employee/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_CHAT_EMPLOYEE_LIST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getDomainUserById = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/user/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DOMAIN_USER_BY_ID,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DOMAIN_USER_BY_ID,
        payload: [],
      });
    });
};

export const addDomainUser = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/user/add`, data, config)
    .then((res) => {
      toast.success('Successfully Added !', {
        position: 'top-right',
      });
      dispatch(getDomainUser());
      // dispatch(getMemberArchived())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updateDomainUser = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/user/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      dispatch(getDomainUser());
      // dispatch(getMemberArchived())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const statusDomainUpdate = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/user/status/toggle`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      dispatch(getDomainUser());
      // dispatch(getMemberArchived())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getSuperAdminDashboardData = () => (dispatch) => {
  axios
    .post(Constant.getAPI() + `domain/dashboard/summary`, {}, config)
    .then((res) => {
      dispatch({
        type: GET_SUPERADMIN_DASHBOARD_DATA,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_SUPERADMIN_DASHBOARD_DATA,
        payload: {},
      });
    });
};

export const getWorkSpace = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employeeWeb/auth/workspace/list`,
      { data },
      config
    )
    .then((res) => {
      dispatch({
        type: GET_WORKSPACE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_WORKSPACE,
        payload: {},
      });
    });
};
export const getDomainProfile = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/auth/profile`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DOMAIN_DETAILS,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_DOMAIN_DETAILS,
        payload: {},
      });
    });
};
export const getTimezoneList = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/auth/timezone/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIMEZONES,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIMEZONES,
        payload: [],
      });
    });
};
export const updateDomainProfile = (data, message) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/auth/detail/update`, data, config)
    .then((res) => {
      toast.success(`${message || 'Profile'} updated!`, {
        position: 'top-right',
      });
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const getEmpDomain = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `employeeWeb/auth/profile`, data, config)
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_DOMAIN,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_DOMAIN,
        payload: {},
      });
    });
};
export const getEmpDashBoard = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `employeeWeb/dashboard/summary`, data, config)
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_DASHBOARD,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_DASHBOARD,
        payload: {},
      });
    });
};
export const getEmpWorkSpace = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `employeeWeb/chat/workspace/get`, data, config)
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_WORKSPACE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_WORKSPACE,
        payload: {},
      });
    });
};
export const getEmpTimesheetMember = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `employeeWeb/timesheet/member/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET_MEMBER,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET_MEMBER,
        payload: {},
      });
    });
};
export const getEmpTimesheetProject = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employeeWeb/timesheet/project/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET_PROJECT,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET_PROJECT,
        payload: {},
      });
    });
};
export const getEmpTimesheetProjectTask = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employeeWeb/timesheet/project/task/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET_PROJECT_TASK,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET_PROJECT_TASK,
        payload: {},
      });
    });
};
export const getEmpTimesheet = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employeeWeb/timesheet/timesheet/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_TIMESHEET,
        payload: {},
      });
    });
};
export const getTimeRequest = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/time-request/list`, data, config)
    .then((res) => {
      dispatch({
        type: GET_TIME_REQUEST,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_TIME_REQUEST,
        payload: {},
      });
    });
};

export const addTiemRequestEmployee = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employeeWeb/timesheet/timesheet/add`,
      data,
      config
    )
    .then((res) => {
      toast.success('Successfully Sent !', {
        position: 'top-right',
      });
      // dispatch(getDomainUser());
      // dispatch(getMemberArchived())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updatedTimeApproved = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/timesheet/time-request/approve`,
      data,
      config
    )
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      window.location.reload();
      // dispatch(getDomainUser());
      // dispatch(getMemberArchived())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const updatedTimeRejected = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `user/timesheet/time-request/reject`,
      data,
      config
    )
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      window.location.reload();
      // dispatch(getDomainUser());
      // dispatch(getMemberArchived())
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};

export const updatedTimeSheetEditor = (data, userID, date) => (dispatch) => {
  axios
    .post(Constant.getAPI() + `user/timesheet/time-editor/edit`, data, config)
    .then((res) => {
      toast.success('Successfully Updated !', {
        position: 'top-right',
      });
      var listP = {
        employeeId: userID,
        date: date,
      };
      dispatch(getTimeEditor(listP));
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error, {
        position: 'top-right',
      });
    });
};
export const removeTimeSheetEditorEntry =
  (data, userID, date) => (dispatch) => {
    axios
      .post(
        Constant.getAPI() + `user/timesheet/time-editor/remove`,
        data,
        config
      )
      .then((res) => {
        toast.success('Successfully Updated !', {
          position: 'top-right',
        });
        var listP = {
          employeeId: userID,
          date: date,
        };
        dispatch(getTimeEditor(listP));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          position: 'top-right',
        });
      });
  };

export const getEmpPastActivities = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `employee/project/project/task/activity/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_PAST_ACTIVITIES,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_PAST_ACTIVITIES,
        payload: [],
      });
    });
};

export const getEmpAppUsages = (data) => (dispatch) => {
  axios
    .post(
      Constant.getAPI() + `/employee/project/appWebsiteDetailsUsage/list`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_EMPLOYEE_APP_USAGE,
        payload: res?.data?.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_EMPLOYEE_APP_USAGE,
        payload: [],
      });
    });
};
